import React from 'react';
import type { Article, Person } from 'schema-dts';

import { LdJson } from '../../scripts/LdJson';
import { validSlug, validString } from '../../utils/schema';

type Props = {
  author?: string;
  dateModified?: string;
  datePublished?: string;
  description?: string;
  includedArtists?: ArtistCard[];
  image?: string;
  slug: string;
  tag?: string;
  title: string;
  wordCount?: number;
};

export const ArticleLd: React.FC<Props> = ({
  author,
  dateModified,
  datePublished,
  description,
  image,
  includedArtists = [],
  slug,
  tag,
  title,
  wordCount,
}) => {
  const person: Person = {
    '@type': 'Person',
    ...validString('name', author),
  };

  const article: Article = {
    '@type': 'Article',
    ...(author ? { author: person } : {}),
    ...validString('dateModified', dateModified),
    ...validString('datePublished', datePublished),
    ...validString('description', description),
    ...validString('headline', title),
    ...validString('image', image),
    ...validString('primaryImageOfPage', image),
    ...validString('keywords', tag),
    'publisher': {
      '@type': 'Organization',
      'name': 'Avant Arte',
      'url': String(process.env.NEXT_PUBLIC_HOSTNAME),
    },
    ...validSlug('url', slug),
    ...validString('wordCount', wordCount ? String(wordCount) : ''),
    ...(includedArtists.length > 0
      ? {
          'about': includedArtists.map((a) => ({
            '@type': 'Person',
            'name': a.name,
            'url': `${process.env.NEXT_PUBLIC_HOSTNAME}${a.link}`,
          })),
        }
      : {}),
  };

  return <LdJson schema={article} />;
};
